const { parseVersion } = require("./pwaVersionCheck");

const SHELL_URLS = [
  "/index.html",
  "/service-worker.js",
  "/",
  "/mhome",
  "/manifest.json",
  "/favicon.ico",
];

function appPath(src) {
  const value = String(src || "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/")) return value;
  return `/${value.replace(/^\.\//, "")}`;
}

function pwaRefreshUrls(manifest) {
  const urls = [...SHELL_URLS];
  const icons = Array.isArray(manifest?.icons) ? manifest.icons : [];
  for (const icon of icons) {
    const path = appPath(icon && icon.src);
    if (path) urls.push(path);
  }
  return [...new Set(urls)];
}

function manifestHrefForIconRefresh(version) {
  const stamp = typeof version === "string" ? version.trim() : "";
  if (!parseVersion(stamp)) return null;
  return `/manifest.json?v=${encodeURIComponent(stamp)}`;
}

async function deleteAllCaches(cacheStorage) {
  if (!cacheStorage || typeof cacheStorage.keys !== "function") return;
  const names = await cacheStorage.keys();
  await Promise.all((names || []).map((name) => cacheStorage.delete(name)));
}

async function purgePwaCaches({ cacheStorage, fetchImpl, urls }) {
  await deleteAllCaches(cacheStorage);
  const list = Array.isArray(urls) ? urls : [];
  await Promise.all(
    list.map((url) =>
      Promise.resolve()
        .then(() =>
          fetchImpl(url, {
            cache: "reload",
            credentials: "same-origin",
            headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
          }),
        )
        .catch(() => null),
    ),
  );
  await deleteAllCaches(cacheStorage);
}

function pointManifestLink(href, doc) {
  if (!href || !doc || typeof doc.querySelector !== "function") return false;
  const link = doc.querySelector('link[rel="manifest"]');
  if (!link || typeof link.setAttribute !== "function") return false;
  link.setAttribute("href", href);
  return true;
}

module.exports = {
  pwaRefreshUrls,
  manifestHrefForIconRefresh,
  purgePwaCaches,
  pointManifestLink,
};

